import React from "react";
import { siteConfig } from "../siteConfig";
import { useQuoteModal } from "../context/QuoteModalContext";
import Reveal from "./Reveal";

/*
  Wave CTA — full-width photo band with wavy white masks on top and bottom.
  The white waves blend with whatever background color the adjacent sections use.
  headline / sub can be overridden per-page; otherwise falls back to siteConfig.cta.
*/
const CTASection = ({
  headline = siteConfig.cta?.headline ?? "Ready to Transform Your Outdoor Space?",
  sub = siteConfig.cta?.sub ?? "Get a free estimate — no pressure, no obligation.",
}) => {
  const { open: openModal } = useQuoteModal();
  const bgImage = siteConfig.cta?.image || siteConfig.hero?.image;
  const btnLabel = siteConfig.cta?.buttonLabel ?? "Get a Free Quote";

  return (
    <section className="relative overflow-hidden" style={{ backgroundColor: siteConfig.colors.light }}>

      {/* ── Top wave mask ── */}
      <div className="absolute top-0 left-0 right-0 z-20 pointer-events-none">
        <svg
          viewBox="0 0 1440 90"
          preserveAspectRatio="none"
          className="w-full block"
          style={{ height: "clamp(50px, 7vw, 90px)" }}
        >
          <path
            d="M0,0 L0,38 C160,82 320,8 480,46 C640,84 800,12 960,48 C1120,84 1280,22 1440,52 L1440,0 Z"
            fill={siteConfig.colors.light}
          />
        </svg>
      </div>

      {/* ── Background photo ── */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* ── Dark overlay ── */}
      <div
        className="absolute inset-0 z-10"
        style={{ background: "linear-gradient(to bottom, rgba(0,0,0,0.62), rgba(0,0,0,0.70))" }}
      />

      {/* ── Content ── */}
      <Reveal as="div" className="relative z-30 py-28 md:py-36 px-5 text-center">
        <h2
          className="font-display font-black text-white uppercase leading-tight mb-5"
          style={{ fontSize: "clamp(1.6rem, 4vw, 2.75rem)", letterSpacing: "-0.01em" }}
        >
          {headline}
        </h2>
        {sub && (
          <p className="text-white/70 text-lg mb-8 max-w-xl mx-auto">{sub}</p>
        )}
        <button
          onClick={openModal}
          className="inline-flex items-center justify-center px-8 h-14 text-sm font-black uppercase tracking-widest text-white rounded-lg transition-opacity hover:opacity-90"
          style={{ backgroundColor: siteConfig.colors.primary, letterSpacing: "0.08em" }}
        >
          {btnLabel}
        </button>
      </Reveal>

      {/* ── Bottom wave mask ── */}
      <div className="absolute bottom-0 left-0 right-0 z-20 pointer-events-none">
        <svg
          viewBox="0 0 1440 90"
          preserveAspectRatio="none"
          className="w-full block"
          style={{ height: "clamp(50px, 7vw, 90px)" }}
        >
          <path
            d="M0,90 L0,52 C160,8 320,82 480,44 C640,6 800,78 960,42 C1120,6 1280,68 1440,38 L1440,90 Z"
            fill={siteConfig.colors.light}
          />
        </svg>
      </div>

    </section>
  );
};

export default CTASection;
